// app/src/api/acupointApi.ts

import { createAsyncThunk } from "@reduxjs/toolkit"
import { serverApi, handleReferenceResponse } from "@core/api/core"
import { AcupointSerializer } from "@/types/acupoint"

export const fetchAcupoints = createAsyncThunk<AcupointSerializer[], void, { rejectValue: string }>(
  "acupoint/fetchAcupoints",
  async (_, { rejectWithValue }) => {
    try {
      const requestUrl = `/acupoint/public/`
      const response = await serverApi.get(requestUrl)

      const data = handleReferenceResponse(response)

      const acupoints: AcupointSerializer[] = data.results.map(row => {
        // columns[i] ↔ row[i] 매핑
        const obj = Object.fromEntries(data.columns.map((col, i) => [col, row[i]])) as Record<string, number | string>

        return {
          acupointId: Number(obj["acupointId"]),
          acupointCode: String(obj["acupointCode"]),
          acupointName: String(obj["acupointName"]),
          acupointPartNo: Number(obj["acupointPartNo"]),
          countsPrivate: Number(obj["countsPrivate"] ?? 0),
        }
      })
      return acupoints
    } catch (err: any) {
      return rejectWithValue(err.message || "혈자리 정보 조회에 실패했습니다.")
    }
  }
)

/**
 * 경혈 데이터를 직접 가져오는 함수 (Redux 없이 사용)
 */
export const getAcupointsData = async (): Promise<AcupointSerializer[]> => {
  const requestUrl = `/acupoint/public/`
  const response = await serverApi.get(requestUrl)

  const data = handleReferenceResponse(response)

  const acupoints: AcupointSerializer[] = data.results.map(row => {
    // columns[i] ↔ row[i] 매핑
    const obj = Object.fromEntries(data.columns.map((col, i) => [col, row[i]])) as Record<string, number | string>

    return {
      acupointId: Number(obj["acupointId"]),
      acupointCode: String(obj["acupointCode"]),
      acupointName: String(obj["acupointName"]),
      acupointPartNo: Number(obj["acupointPartNo"]),
      countsPrivate: Number(obj["countsPrivate"] ?? 0),
    }
  })
  return acupoints
}
